module.exports = __webpack_public_path__ + "static/img/technology-top.c0484190.png";